import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "capacity"
const CapacityIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M13.196 2.143a3.21 3.21 0 0 0-2.388 0L8.306 3.144 17.949 7l3.52-1.409a2.4 2.4 0 0 0-.664-.404zm3.021 5.55L6.574 3.836 3.2 5.186a2.3 2.3 0 0 0-.665.405l9.468 3.789zm-14.5-.317q.001-.357.102-.686l9.54 3.817v11.516a3.4 3.4 0 0 1-.551-.165l-7.61-3.044a2.36 2.36 0 0 1-1.48-2.189zm11.479 14.481q-.271.108-.551.165V10.507l9.54-3.817q.1.33.1.686v9.25a2.36 2.36 0 0 1-1.48 2.188z" />
    </svg>
  )
}
export default CapacityIcon
